import React from 'react';
import { LABEL_BACKGROUND_COLOR, LABEL_BORDER_RADIUS, LABEL_FONT_FAMILY, LABEL_FONT_SIZE, LABEL_TEXT_COLOR } from '../../constants/relationship-renderer';
import { getCounterScaleStyle, getLabelDimensions } from '../../utils/relationship-renderer';
type PropsT = {
  center: [number, number];
  names: string[];
  backgroundColor?: string;
  textColor?: string;
};
const SEPARATOR = ' · ';
const EdgeLabel = ({
  center,
  names,
  backgroundColor,
  textColor
}: PropsT) => {
  const [centerX, centerY] = center;
  const [isHovered, setIsHovered] = React.useState(false);
  const hasMultiple = names.length > 1;
  const firstName = names[0] ?? '';
  const collapsed = hasMultiple ? `${firstName} +${names.length - 1}` : firstName;
  const expanded = names.join(SEPARATOR);
  const displayText = isHovered ? expanded : collapsed;
  const {
    width,
    height
  } = getLabelDimensions(displayText);
  return <g style={getCounterScaleStyle(centerX, centerY)} onMouseEnter={() => hasMultiple && setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <rect x={centerX - width / 2} y={centerY - height / 2} width={width} height={height} rx={LABEL_BORDER_RADIUS} fill={backgroundColor || LABEL_BACKGROUND_COLOR} />
      <text x={centerX} y={centerY} textAnchor="middle" dominantBaseline="central" fill={textColor || LABEL_TEXT_COLOR} fontSize={LABEL_FONT_SIZE} fontFamily={LABEL_FONT_FAMILY}>
        {displayText}
      </text>
    </g>;
};
export default EdgeLabel;